/**
 * Human-readable labels + intake grouping for the 16 task types
 * (enums.taskTypeSchema / DATA-05). Used by the kanban card, task detail, and
 * the intake type selector (T-039).
 */

import type { TaskType } from '@studio/api-schemas';

export const TASK_TYPE_LABEL: Record<TaskType, string> = {
  positioning_clarity: 'Positioning clarity',
  icp_synthesis: 'ICP synthesis',
  competitive_landscape: 'Competitive landscape',
  pricing_strategy: 'Pricing strategy',
  gtm_strategy: 'Go-to-market strategy',
  messaging_architecture: 'Messaging architecture',
  voice_encoding: 'Voice encoding',
  pitch_deck_review: 'Pitch deck review',
  landing_page_copy: 'Landing page copy',
  product_strategy: 'Product strategy',
  user_research_synthesis: 'User research synthesis',
  prototyping: 'Prototyping',
  ai_workflow_design: 'AI workflow design',
  ai_coaching: 'AI coaching',
  internal_tool_build: 'Internal tool build',
  other: 'Other',
};

/**
 * Grouped options for the intake dropdown (T-039). Order mirrors the grouping
 * comment in enums.ts.
 */
export const TASK_TYPE_GROUPS: ReadonlyArray<{
  group: string;
  types: ReadonlyArray<TaskType>;
}> = [
  {
    group: 'Strategy & positioning',
    types: [
      'positioning_clarity',
      'icp_synthesis',
      'competitive_landscape',
      'pricing_strategy',
      'gtm_strategy',
    ],
  },
  {
    group: 'Messaging & voice',
    types: [
      'messaging_architecture',
      'voice_encoding',
      'pitch_deck_review',
      'landing_page_copy',
    ],
  },
  {
    group: 'Product & research',
    types: ['product_strategy', 'user_research_synthesis', 'prototyping'],
  },
  {
    group: 'AI & tooling',
    types: ['ai_workflow_design', 'ai_coaching', 'internal_tool_build'],
  },
  {
    group: 'Other',
    types: ['other'],
  },
];
